<div class="content">
  <app-order-form #orderForm [order]="order"></app-order-form>
</div>

<div class="footer">
  <button pButton pRipple type="button" (click)="closeDialog()">Cancel</button>
  <button pButton pRipple type="button" (click)="onSubmit()" [disabled]="!isFormValid">
    {{ btnLabel }} Order
  </button>
</div>
